import axios from 'axios'
import { URL_BASE } from '@/configs/constants'

const RESOURCE = 'check-management'

export default {
  loadCheckManagements(context, params) {
    context.commit('LOADER', true)
    return new Promise((resolve, reject) => {
      axios
        .get(`${URL_BASE}${RESOURCE}`, { params })
        .then(response => {
          const data = response.data || {}
          const items = data.items || data
          context.commit('CHECK_MANAGEMENT', items)
          context.commit('CHECK_MANAGEMENT_TOTALS', {
            total_compensated: data.total_compensated || '0,00',
            total_due: data.total_due || '0,00',
            total_overdue: data.total_overdue || '0,00',
            total_general: data.total_general || '0,00'
          })
          return resolve(items)
        })
        .catch(errors => {
          return reject(errors)
        })
        .finally(() => context.commit('LOADER', false))
    })
  },

  storeCheckManagement(context, formData) {
    context.commit('LOADER', true)
    return new Promise((resolve, reject) => {
      axios
        .post(`${URL_BASE}${RESOURCE}`, formData)
        .then(response => {
          return resolve(response.data)
        })
        .catch(errors => {
          return reject(errors)
        })
        .finally(() => context.commit('LOADER', false))
    })
  },

  loadCheckManagement(context, id) {
    context.commit('LOADER', true)
    return new Promise((resolve, reject) => {
      axios
        .get(`${URL_BASE}${RESOURCE}/${id}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(errors => {
          return reject(errors)
        })
        .finally(() => context.commit('LOADER', false))
    })
  },

  updateCheckManagement(context, formData) {
    context.commit('LOADER', true)
    return new Promise((resolve, reject) => {
      axios
        .put(`${URL_BASE}${RESOURCE}/${formData.id}`, formData)
        .then(response => {
          return resolve(response.data)
        })
        .catch(errors => {
          return reject(errors)
        })
        .finally(() => context.commit('LOADER', false))
    })
  },

  destroyCheckManagement(context, id) {
    context.commit('LOADER', true)
    return new Promise((resolve, reject) => {
      axios
        .delete(`${URL_BASE}${RESOURCE}/${id}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(errors => {
          return reject(errors)
        })
        .finally(() => context.commit('LOADER', false))
    })
  },

  updateCheckManagementStatus(context, formData) {
    context.commit('LOADER', true)
    return new Promise((resolve, reject) => {
      axios
        .put(`${URL_BASE}${RESOURCE}-status/${formData.id}`, formData)
        .then(response => {
          return resolve(response.data)
        })
        .catch(errors => {
          return reject(errors)
        })
        .finally(() => context.commit('LOADER', false))
    })
  },

  loadCheckManagementPhotos(context, id) {
    context.commit('LOADER', true)
    return new Promise((resolve, reject) => {
      axios
        .get(`${URL_BASE}${RESOURCE}-photo/${id}`)
        .then(response => {
          const data = response.data
          return resolve(Array.isArray(data) ? data : data?.data || [])
        })
        .catch(errors => {
          return reject(errors)
        })
        .finally(() => context.commit('LOADER', false))
    })
  },

  storeCheckManagementPhoto(context, formData) {
    context.commit('LOADER', true)
    const config = { headers: { 'Content-Type': 'multipart/form-data' } }
    return new Promise((resolve, reject) => {
      axios
        .post(`${URL_BASE}${RESOURCE}-photo`, formData, config)
        .then(response => {
          return resolve(response.data)
        })
        .catch(errors => {
          return reject(errors)
        })
        .finally(() => context.commit('LOADER', false))
    })
  },

  destroyCheckManagementPhoto(context, id) {
    context.commit('LOADER', true)
    return new Promise((resolve, reject) => {
      axios
        .delete(`${URL_BASE}${RESOURCE}-photo/${id}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(errors => {
          return reject(errors)
        })
        .finally(() => context.commit('LOADER', false))
    })
  }
}
